export default __webpack_public_path__ + "e406c03b21628909a8ef62ed6e1250ed.png";